import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ICounts } from 'src/interfaces/counts'

type State = {
  loading: boolean
  entity: ICounts | null
}

const initialState: State = {
  loading: false,
  entity: null,
}

const { actions, reducer } = createSlice({
  name: 'counts',
  initialState,
  reducers: {
    updateEntity: (state, action: PayloadAction<ICounts>) => {
      state.entity = action.payload
    },
    updateLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
  },
})

export { reducer }
export default actions
